import {Component, h, Host} from '@stencil/core';

/** @internal **/
@Component({
    tag: 'joy-product-tour-spotlight',
    styleUrl: 'product-tour-spotlight.scss',
    shadow: true,
})
export class ProductTourSpotlight {
    render() {
        return <Host />;
    }
}
